import { gql } from '@apollo/client';

export const LOGIN_RESOLUTION = gql`
  query LoginResolution($input: LoginResolutionInput!) {
    loginResolution(input: $input) {
      method
      tenantId
      providerId
    }
  }
`;

export const TENANT_INFO = gql`
  query TenantInfo($input: TenantInfoInput!) {
    tenantInfo(input: $input) {
      tenantId
      providerId
    }
  }
`;
